import React from 'react'
import GlassPanel from '../UI/GlassPanel'
import FormField from '../Forms/FormField'

const EventReviewSection = ({ event, onChange }) => {
  const StarRating = ({ rating, onRatingChange }) => {
    return (
      <div className="flex gap-1 mb-2">
        {[1, 2, 3, 4, 5].map((star) => (
          <button
            key={star}
            type="button"
            onClick={() => onRatingChange(star)}
            className={`transition-colors ${
              star <= rating ? 'text-yellow-400' : 'text-black hover:text-yellow-200'
            }`}
          >
            <svg
              className="w-6 h-6"
              fill={star <= rating ? "currentColor" : "none"}
              stroke={star <= rating ? "none" : "currentColor"}
              strokeWidth={star <= rating ? "0" : "2"}
              viewBox="0 0 24 24"
            >
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
            </svg>
          </button>
        ))}
      </div>
    )
  }

  const handleRatingChange = (rating) => {
    onChange({
      target: {
        name: 'rating',
        value: rating,
        type: 'number'
      }
    })
  }

  return (
    <GlassPanel className="p-6 mb-8">
      <h2 className="text-xl font-semibold text-white mb-6">⭐ Event Review & Experience</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <div>
          <label className="block text-sm font-medium text-gray-200 mb-2">Overall Rating</label>
          <StarRating rating={parseInt(event.rating) || 0} onRatingChange={handleRatingChange} />
          <p className="text-xs text-gray-400">Rate your overall experience</p>
        </div>

        <FormField
          label="Favorite Performance"
          name="favoritePerformance"
          value={event.favoritePerformance}
          onChange={onChange}
          placeholder="Who was your favorite act?"
        />
      </div>

      <div className="mb-6">
        <FormField
          label="Event Notes"
          name="notes"
          value={event.notes}
          onChange={onChange}
          placeholder="Share your thoughts, memories, highlights..."
          multiline
          rows={4}
        />
      </div>

      <div className="mb-6">
        <FormField
          label="Notable Details"
          name="notableDetails"
          value={event.notableDetails}
          onChange={onChange}
          placeholder="Any special moments, surprises, or unique aspects?"
          multiline
          rows={3}
        />
      </div>

      {/* Memorable Moment */}
      <div className="space-y-4">
        <div className="flex items-center gap-3">
          <input
            type="checkbox"
            id="memorableMoment"
            name="memorableMoment"
            checked={event.memorableMoment}
            onChange={onChange}
            className="w-5 h-5 text-purple-600 bg-white/10 border-white/20 rounded focus:ring-purple-500"
          />
          <label htmlFor="memorableMoment" className="text-white font-medium">
            📸 I have a memorable moment to share
          </label>
        </div>

        {event.memorableMoment && (
          <FormField
            label="Moment Caption"
            name="momentCaption"
            value={event.momentCaption}
            onChange={onChange}
            placeholder="Describe your memorable moment..."
            multiline
            rows={2}
          />
        )}
      </div>
    </GlassPanel>
  )
}

export default EventReviewSection